// Custom GraphQL queries that exclude non-nullable DataStore fields (_version, _lastChangedAt)
// These are used to prevent null item errors when database records don't have these fields

export const zatcaInvoicesByDeletedCustom = /* GraphQL */ `
  query ZatcaInvoicesByDeleted(
    $deleted: String!
    $sortDirection: ModelSortDirection
    $filter: ModelZatcaInvoiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    zatcaInvoicesByDeleted(
      deleted: $deleted
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conceptID
        invoiceCounterNumber
        invoiceSerialNumber
        invoiceHash
        isUsed
        pcsid
        billNumber
        invoiceRefrence
        folioNumber
        customerID
        customer {
          id
          accountID
          ArNumber
          type
          name
          registrationNumber
          address {
            branchId
            country
            governate
            regionCity
            citySubdivision
            plotIdentification
            street
            buildingNumber
            postalCode
            floor
            room
            landmark
            additionalInformation
            __typename
          }
          mobileNumber
          paymentNumber
          deleted
          createdAt
          createdByID
          createdByName
          updatedAt
          __typename
        }
        documentType
        type
        status
        dateTimeIssued
        invoiceLines {
          id
          name
          quantity
          taxExclusivePrice
          vatPercent
          discounts {
            amount
            description
            __typename
          }
          VatExemptionReason
          priceAmount
          taxAmount
          roundingAmount
          __typename
        }
        taxExclusiveAmount
        taxInclusiveAmount
        allowanceTotalAmount
        prepaidAmount
        payableAmount
        xmlDocumentEncoded
        uuid
        failureReason
        qrString
        qrImage
        infoMessages
        warningMessages
        errorMessages
        isCancelled
        clearanceStatus
        reportingStatus
        deleted
        createdAt
        createdByID
        createdByName
        updatedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const listAccountsCustom = /* GraphQL */ `
  query ListAccounts(
    $filter: ModelAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        logo
        domain
        siteTitle
        guestsCount
        tagline
        description
        siteAddress
        defaultLanguage
        languages
        features
        status
        socialLinks
        hasZATCAClearance
        deleted
        createdAt
        createdByID
        createdByName
        callCenterEmployeesIds
        updatedAt
        _deleted
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const listConceptsCustom = /* GraphQL */ `
  query ListConcepts(
    $filter: ModelConceptFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listConcepts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        accountID
        name
        hotelCode
        env
        prefix
        type
        rin
        crn
        productionCertificate
        productionApiSecret
        companyTradeName
        branchCode
        activityCode
        deviceSerialNumber
        branchAddress {
          branchId
          country
          governate
          regionCity
          citySubdivision
          plotIdentification
          street
          buildingNumber
          postalCode
          floor
          room
          landmark
          additionalInformation
          __typename
        }
        clientId
        clientSecret
        posSerial
        posVersion
        synchronizeProcess
        deleted
        createdAt
        updatedAt
        _deleted
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const listCustomersCustom = /* GraphQL */ `
  query ListCustomers(
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        accountID
        ArNumber
        type
        name
        registrationNumber
        address {
          branchId
          country
          governate
          regionCity
          citySubdivision
          plotIdentification
          street
          buildingNumber
          postalCode
          floor
          room
          landmark
          additionalInformation
          __typename
        }
        mobileNumber
        paymentNumber
        deleted
        createdAt
        updatedAt
        _deleted
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const listFeaturesCustom = /* GraphQL */ `
  query ListFeatures(
    $filter: ModelFeatureFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFeatures(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        icon
        slug
        precedence
        parent
        private
        deleted
        createdAt
        createdByID
        createdByName
        updatedAt
        _deleted
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const listAdminRolesCustom = /* GraphQL */ `
  query ListAdminRoles(
    $filter: ModelAdminRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAdminRoles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        deleted
        createdAt
        createdByID
        createdByName
        updatedAt
        _deleted
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const listAdminGroupsCustom = /* GraphQL */ `
  query ListAdminGroups(
    $filter: ModelAdminGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAdminGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        roles
        users
        deleted
        createdAt
        createdByID
        createdByName
        updatedAt
        _deleted
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

// Same as listAdminGroupsCustom but also fetches _version. Use ONLY for
// update flows that need to pass _version (to bypass AUTOMERGE union of
// list fields). Older records without _version will come back as null
// items — filter them out and use the version-less write as fallback.
export const listAdminGroupsWithVersion = /* GraphQL */ `
  query ListAdminGroups(
    $filter: ModelAdminGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAdminGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        users
        _version
      }
      nextToken
    }
  }
`;

export const listUserConceptsCustom = /* GraphQL */ `
  query ListUserConcepts(
    $filter: ModelUserConceptsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserConcepts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        defaultConcept
        concepts
        conceptsRoles
        deleted
        createdAt
        createdByID
        createdByName
        updatedAt
        _deleted
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const listLanguagesCustom = /* GraphQL */ `
  query ListLanguages(
    $filter: ModelLanguageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLanguages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        code
        deleted
        createdAt
        createdByID
        createdByName
        updatedAt
        _deleted
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const listTimelinesCustom = /* GraphQL */ `
  query ListTimelines(
    $filter: ModelTimelineFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTimelines(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        actionName
        oldStatus
        newStatus
        userId
        transactionId
        deleted
        createdAt
        createdByID
        createdByName
        updatedAt
        _deleted
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const listItemsCustom = /* GraphQL */ `
  query ListItems(
    $filter: ModelItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        accountID
        internalCode
        itemCode
        description
        type
        unit
        tax1
        tax2
        neglectedItem
        deleted
        createdAt
        updatedAt
        _deleted
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const listReceiptsCustom = /* GraphQL */ `
  query ListReceipts(
    $filter: ModelReceiptFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReceipts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        conceptID
        checkNumber
        uuid
        submissionId
        header {
          dateTimeIssued
          receiptNumber
          uuid
          previousUUID
          currency
          exchangeRate
          grossWeight
          netWeight
          __typename
        }
        documentType {
          receiptType
          typeVersion
          __typename
        }
        seller {
          rin
          companyTradeName
          branchCode
          branchAddress {
            branchId
            country
            governate
            regionCity
            citySubdivision
            plotIdentification
            street
            buildingNumber
            postalCode
            floor
            room
            landmark
            additionalInformation
            __typename
          }
          deviceSerialNumber
          activityCode
          __typename
        }
        buyer {
          type
          id
          name
          mobileNumber
          paymentNumber
          __typename
        }
        itemData {
          internalCode
          description
          itemType
          itemCode
          unitType
          quantity
          unitPrice
          netSale
          totalSale
          total
          commercialDiscountData {
            amount
            description
            __typename
          }
          itemDiscountData {
            amount
            description
            __typename
          }
          valueDifference
          taxableItems {
            taxType
            amount
            subType
            rate
            __typename
          }
          __typename
        }
        totalSales
        totalCommercialDiscount
        totalItemsDiscount
        extraReceiptDiscountData {
          amount
          description
          __typename
        }
        netAmount
        feesAmount
        totalAmount
        taxTotals {
          taxType
          amount
          __typename
        }
        paymentMethod
        qrString
        qrImage
        status
        reason
        type
        returned
        deleted
        createdAt
        createdByID
        createdByName
        updatedAt
        _deleted
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const listInvoicesCustom = /* GraphQL */ `
  query ListInvoices(
    $filter: ModelInvoiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInvoices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        conceptID
        issuer {
          type
          id
          name
          address {
            branchId
            country
            governate
            citySubdivision
            plotIdentification
            postalCode
            floor
            room
            landmark
            additionalInformation
            __typename
          }
          __typename
        }
        receiver {
          type
          id
          name
          address {
            branchId
            country
            governate
            citySubdivision
            plotIdentification
            postalCode
            floor
            room
            landmark
            additionalInformation
            __typename
          }
          __typename
        }
        documentType
        documentTypeVersion
        dateTimeIssued
        taxpayerActivityCode
        internalID
        folioNumber
        roomNumber
        invoiceLines {
          itemCode
          description
          quantity
          unitValue {
            amountEGP
            currencySold
            amountSold
            currencyExchangeRate
          }
          taxableItems {
            taxType
            amount
            subType
            rate
          }

        }

        totalSalesAmount
        netAmount
        taxTotals {
            taxType
            amount
            __typename
        }
        totalAmount
        purchaseOrderReference
        uuid
        type
        cancelReason
        qrString
        qrImage
        status
        reason
        deleted
        createdAt
        createdByID
        createdByName
        updatedAt
        _deleted
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const listZatcaInvoicesCustom = /* GraphQL */ `
  query ListZatcaInvoices(
    $filter: ModelZatcaInvoiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listZatcaInvoices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        conceptID
        invoiceCounterNumber
        invoiceSerialNumber
        invoiceHash
        isUsed
        pcsid
        billNumber
        invoiceRefrence
        folioNumber
        customerID
        customer {
          id
          accountID
          ArNumber
          type
          name
          registrationNumber
          address {
            branchId
            country
            governate
            regionCity
            citySubdivision
            plotIdentification
            street
            buildingNumber
            postalCode
            floor
            room
            landmark
            additionalInformation
            __typename
          }
          mobileNumber
          paymentNumber
          deleted
          createdAt
          createdByID
          createdByName
          updatedAt
          _deleted
          __typename
        }
        documentType
        type
        status
        dateTimeIssued
        invoiceLines {
          id
          name
          quantity
          taxExclusivePrice
          vatPercent
          discounts {
            amount
            description
            __typename
          }
          VatExemptionReason
          priceAmount
          taxAmount
          roundingAmount
          __typename
        }
        taxExclusiveAmount
        taxInclusiveAmount
        allowanceTotalAmount
        prepaidAmount
        payableAmount
        xmlDocumentEncoded
        uuid
        failureReason
        qrString
        qrImage
        infoMessages
        warningMessages
        errorMessages
        isCancelled
        clearanceStatus
        reportingStatus
        deleted
        createdAt
        createdByID
        createdByName
        updatedAt
        _deleted
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const listInvokersCustom = /* GraphQL */ `
  query ListInvokers(
    $filter: ModelInvokerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInvokers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        conceptID
        userName
        password
        operations
        deleted
        createdAt
        createdByID
        createdByName
        updatedAt
        _deleted
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const listZatcaInvoicesSequencesCustom = /* GraphQL */ `
  query ListZatcaInvoicesSequences(
    $filter: ModelZatcaInvoicesSequenceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listZatcaInvoicesSequences(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conceptID
        invoiceCounterNumber
        invoiceHash
        isUsed
        pcsid
        deleted
        createdAt
        createdByID
        createdByName
        updatedAt
        _deleted
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

// ==========================================
// CUSTOM GET QUERIES
// These exclude _version and _lastChangedAt to prevent null errors
// ==========================================

export const getAccountCustom = /* GraphQL */ `
  query GetAccount($id: ID!) {
    getAccount(id: $id) {
      id
      logo
      domain
      siteTitle
      guestsCount
      tagline
      description
      siteAddress
      defaultLanguage
      languages
      features
      status
      socialLinks
      hasZATCAClearance
      deleted
      createdAt
      createdByID
      createdByName
      callCenterEmployeesIds
      updatedAt
      _deleted
      __typename
    }
  }
`;

export const getConceptCustom = /* GraphQL */ `
  query GetConcept($id: ID!) {
    getConcept(id: $id) {
      id
      accountID
      name
      hotelCode
      env
      prefix
      type
      rin
      crn
      productionCertificate
      productionApiSecret
      companyTradeName
      branchCode
      activityCode
      deviceSerialNumber
      branchAddress {
        branchId
        country
        governate
        regionCity
        citySubdivision
        plotIdentification
        street
        buildingNumber
        postalCode
        floor
        room
        landmark
        additionalInformation
        __typename
      }
      clientId
      clientSecret
      posSerial
      posVersion
      synchronizeProcess
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _deleted
      __typename
    }
  }
`;

export const getCustomerCustom = /* GraphQL */ `
  query GetCustomer($id: ID!) {
    getCustomer(id: $id) {
      id
      accountID
      ArNumber
      type
      name
      registrationNumber
      address {
        branchId
        country
        governate
        regionCity
        citySubdivision
        plotIdentification
        street
        buildingNumber
        postalCode
        floor
        room
        landmark
        additionalInformation
        __typename
      }
      mobileNumber
      paymentNumber
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _deleted
      __typename
    }
  }
`;

export const getFeatureCustom = /* GraphQL */ `
  query GetFeature($id: ID!) {
    getFeature(id: $id) {
      id
      name
      icon
      slug
      precedence
      parent
      private
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _deleted
      __typename
    }
  }
`;

export const getAdminRoleCustom = /* GraphQL */ `
  query GetAdminRole($id: ID!) {
    getAdminRole(id: $id) {
      id
      name
      description
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _deleted
      __typename
    }
  }
`;

export const getAdminGroupCustom = /* GraphQL */ `
  query GetAdminGroup($id: ID!) {
    getAdminGroup(id: $id) {
      id
      name
      description
      roles
      users
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _deleted
      __typename
    }
  }
`;

export const getUserConceptsCustom = /* GraphQL */ `
  query GetUserConcepts($id: ID!) {
    getUserConcepts(id: $id) {
      id
      defaultConcept
      concepts
      conceptsRoles
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _deleted
      __typename
    }
  }
`;

export const getLanguageCustom = /* GraphQL */ `
  query GetLanguage($id: ID!) {
    getLanguage(id: $id) {
      id
      name
      code
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _deleted
      __typename
    }
  }
`;

export const getTimelineCustom = /* GraphQL */ `
  query GetTimeline($id: ID!) {
    getTimeline(id: $id) {
      id
      actionName
      oldStatus
      newStatus
      userId
      transactionId
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _deleted
      __typename
    }
  }
`;

export const getItemCustom = /* GraphQL */ `
  query GetItem($id: ID!) {
    getItem(id: $id) {
      id
      accountID
      internalCode
      itemCode
      description
      type
      unit
      tax1
      tax2
      neglectedItem
      deleted
      createdAt
      updatedAt
      _deleted
      __typename
    }
  }
`;

export const getInvokerCustom = /* GraphQL */ `
  query GetInvoker($id: ID!) {
    getInvoker(id: $id) {
      id
      conceptID
      userName
      password
      operations
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _deleted
      __typename
    }
  }
`;

export const customerByDeletedCustom = /* GraphQL */ `
  query CustomerByDeleted(
    $deleted: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerByDeleted(
      deleted: $deleted
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountID
        ArNumber
        type
        name
        registrationNumber
        address {
          branchId
          country
          governate
          regionCity
          citySubdivision
          plotIdentification
          street
          buildingNumber
          postalCode
          floor
          room
          landmark
          additionalInformation
          __typename
        }
        mobileNumber
        paymentNumber
        deleted
        createdAt
        createdByID
        createdByName
        updatedAt
        _deleted
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const getZatcaInvoiceCustom = /* GraphQL */ `
  query GetZatcaInvoice($id: ID!) {
    getZatcaInvoice(id: $id) {
      id
      conceptID
      invoiceCounterNumber
      invoiceSerialNumber
      invoiceHash
      isUsed
      pcsid
      billNumber
      invoiceRefrence
      folioNumber
      customerID
      customer {
        id
        accountID
        ArNumber
        type
        name
        registrationNumber
        address {
          branchId
          country
          governate
          regionCity
          citySubdivision
          plotIdentification
          street
          buildingNumber
          postalCode
          floor
          room
          landmark
          additionalInformation
          __typename
        }
        mobileNumber
        paymentNumber
        deleted
        createdAt
        updatedAt
        _deleted
        __typename
      }
      documentType
      type
      status
      dateTimeIssued
      invoiceLines {
        id
        name
        quantity
        taxExclusivePrice
        vatPercent
        discounts {
          amount
          description
          __typename
        }
        VatExemptionReason
        priceAmount
        taxAmount
        roundingAmount
        __typename
      }
      taxExclusiveAmount
      taxInclusiveAmount
      allowanceTotalAmount
      prepaidAmount
      payableAmount
      xmlDocumentEncoded
      uuid
      failureReason
      qrString
      qrImage
      infoMessages
      warningMessages
      errorMessages
      isCancelled
      clearanceStatus
      reportingStatus
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _deleted
      __typename
    }
  }
`;

/** `id` / `deleted` only — safe for legacy rows with null `_version` (schema declares Int!) */
export const getInvoiceTrashMetaSafe = /* GraphQL */ `
  query GetInvoiceTrashMetaSafe($id: ID!) {
    getInvoice(id: $id) {
      id
      deleted
      __typename
    }
  }
`;

/** Second request; fails for legacy null `_version` — caller must catch / check `errors` and omit `_version` from mutations. */
export const getInvoiceTrashVersionProbe = /* GraphQL */ `
  query GetInvoiceTrashVersionProbe($id: ID!) {
    getInvoice(id: $id) {
      id
      _version
      __typename
    }
  }
`;

export const getInvoiceCustom = /* GraphQL */ `
  query GetInvoice($id: ID!) {
    getInvoice(id: $id) {
      id
      conceptID
      issuer {
        type
        id
        name
        address {
          branchId
          country
          governate
          regionCity
          citySubdivision
          plotIdentification
          street
          buildingNumber
          postalCode
          floor
          room
          landmark
          additionalInformation
          __typename
        }
        __typename
      }
      receiver {
        type
        id
        name
        address {
          branchId
          country
          governate
          regionCity
          citySubdivision
          plotIdentification
          street
          buildingNumber
          postalCode
          floor
          room
          landmark
          additionalInformation
          __typename
        }
        __typename
      }
      documentType
      documentTypeVersion
      dateTimeIssued
      taxpayerActivityCode
      internalID
      folioNumber
      roomNumber
      invoiceLines {
        itemCode
        description
        quantity
        unitValue {
          amountEGP
          currencySold
          amountSold
          currencyExchangeRate
        }
        taxableItems {
            taxType
            amount
            subType
            rate
        }
        netTotal
        salesTotal
        total
        totalTaxableFees
        valueDifference
        itemsDiscount
        itemType
        unitType
        internalCode
      }
      totalDiscountAmount
      totalSalesAmount
      netAmount
      taxTotals {
        taxType
        amount
        __typename
      }
      totalAmount
      extraDiscountAmount
      totalItemsDiscountAmount
      purchaseOrderReference
      uuid
      type
      cancelReason
      qrString
      qrImage
      status
      reason
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      _deleted
      __typename
     }
  }
`;

export const invoiceByConceptCustom = /* GraphQL */ `
  query InvoiceByConcept(
    $conceptID: ID!
    $internalID: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInvoiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoiceByConcept(
      conceptID: $conceptID
      internalID: $internalID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conceptID
        issuer {
          type
          id
          name
          address {
            branchId
            country
            governate
            citySubdivision
            plotIdentification
            postalCode
            floor
            room
            landmark
            additionalInformation
            __typename
          }
          __typename
        }
        receiver {
          type
          id
          name
          address {
            branchId
            country
            governate
            citySubdivision
            plotIdentification
            postalCode
            floor
            room
            landmark
            additionalInformation
            __typename
          }
          __typename
        }
        documentType
        documentTypeVersion
        dateTimeIssued
        taxpayerActivityCode
        internalID
        folioNumber
        roomNumber
        invoiceLines {
          itemCode
          description
          quantity
          unitValue {
            amountEGP
            currencySold
            amountSold
            currencyExchangeRate
          }
          taxableItems {
            taxType
            amount
            subType
            rate
          }
          netTotal
          salesTotal
          total
          totalTaxableFees
          valueDifference
          itemsDiscount
          itemType
          unitType
          internalCode
        }
        totalSalesAmount
        netAmount
        taxTotals {
            taxType
            amount
            __typename
        }
        totalAmount
        extraDiscountAmount
        totalItemsDiscountAmount
        purchaseOrderReference
        uuid
        type
        cancelReason
        qrString
        qrImage
        status
        reason
        deleted
        createdAt
        createdByID
        createdByName
        updatedAt
        _deleted
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

/** Minimal fields for duplicate Folio / BillNo checks — avoids nested Invoice fields that break on legacy rows. */
export const invoiceByConceptDuplicateCustom = /* GraphQL */ `
  query InvoiceByConcept(
    $conceptID: ID!
    $internalID: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInvoiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoiceByConcept(
      conceptID: $conceptID
      internalID: $internalID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conceptID
        internalID
        folioNumber
        uuid
        status
        deleted
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const invoiceByConceptDateCustom = /* GraphQL */ `
  query InvoiceByConceptDate(
    $conceptID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInvoiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoiceByConceptDate(
      conceptID: $conceptID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conceptID
        issuer {
          type
          id
          name
          address {
            branchId
            country
            governate
            citySubdivision
            plotIdentification
            postalCode
            floor
            room
            landmark
            additionalInformation
            __typename
          }
          __typename
        }
        receiver {
          type
          id
          name
          address {
            branchId
            country
            governate
            citySubdivision
            plotIdentification
            postalCode
            floor
            room
            landmark
            additionalInformation
            __typename
          }
          __typename
        }
        documentType
        documentTypeVersion
        dateTimeIssued
        taxpayerActivityCode
        internalID
        folioNumber
        roomNumber
        invoiceLines {
          itemCode
          description
          quantity
          unitValue {
            amountEGP
            currencySold
            amountSold
            currencyExchangeRate
          }
          taxableItems {
            taxType
            amount
            subType
            rate
          }
          netTotal
          salesTotal
          total
          totalTaxableFees
          valueDifference
          itemsDiscount
          itemType
          unitType
          internalCode
        }
        totalSalesAmount
        netAmount
        taxTotals {
            taxType
            amount
            __typename
        }
        totalAmount
        extraDiscountAmount
        totalItemsDiscountAmount
        purchaseOrderReference
        uuid
        type
        cancelReason
        qrString
        qrImage
        status
        reason
        deleted
        createdAt
        createdByID
        createdByName
        updatedAt
        _deleted
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const customerByArNumberCustom = /* GraphQL */ `
  query CustomerByArNumber(
    $ArNumber: String!
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerByArNumber(
      ArNumber: $ArNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountID
        ArNumber
        type
        name
        registrationNumber
        address {
          branchId
          country
          governate
          regionCity
          citySubdivision
          plotIdentification
          street
          buildingNumber
          postalCode
          floor
          room
          landmark
          additionalInformation
          __typename
        }
        mobileNumber
        paymentNumber
        deleted
        createdAt
        updatedAt
        _deleted
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

export const customerByRegistrationNumberCustom = /* GraphQL */ `
  query CustomerByRegistrationNumber(
    $registrationNumber: String!
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerByRegistrationNumber(
      registrationNumber: $registrationNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountID
        ArNumber
        type
        name
        registrationNumber
        address {
          branchId
          country
          governate
          regionCity
          citySubdivision
          plotIdentification
          street
          buildingNumber
          postalCode
          floor
          room
          landmark
          additionalInformation
          __typename
        }
        mobileNumber
        paymentNumber
        deleted
        createdAt
        updatedAt
        _deleted
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;

/** Minimal fields only — avoids _version/_lastChangedAt which are null on legacy Invoice rows. */
export const invoiceByFolioNumberCustom = /* GraphQL */ `
  query InvoiceByFolioNumber(
    $folioNumber: String!
    $sortDirection: ModelSortDirection
    $filter: ModelInvoiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoiceByFolioNumber(
      folioNumber: $folioNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conceptID
        internalID
        folioNumber
        uuid
        status
        deleted
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
